import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Col, Container, Spinner } from 'react-bootstrap'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import FormQuickBook from './Includes/FormQuickBook'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import { editSettings, getSettings } from 'utlis/Apis/QuickBooks_API'
import { ERROR_WHILE_FETCHING_QUICKBOOKS_SETTINGS } from 'utlis/AppMessages/AppMessages'
import { QUICKBOOKS_SETTINGS_UPDATED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages'
import { formValidationSchema, initialFormValues } from './Includes/Helper'
import { getFromLocalStorage } from 'utlis/helpers/Common/CommonHelperFunctions'

function QuickBooksSetting(props) {
    const submitButtonRef = useRef(null)
    const [buttonDisable, setButtonDisable] = useState(false)
    const [createButtonLoading, setCreateButtonLoading] = useState(false)
    const [settings, setSettings] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const qb_realm_id = getFromLocalStorage("qb_realm_id")
        if (!qb_realm_id) {
            props.history.push('/settings/integration/quickbooks/connect')
        } else {
            getSettings(qb_realm_id).then(res => {
                setLoading(loading)
                const resData = res.data
                window.scrollTo(0, 0)
                if (resData && resData.success) {
                    setSettings(resData.data)
                }
                if (resData && resData.error) {
                    toast.dismiss();
                    toast.error(ERROR_WHILE_FETCHING_QUICKBOOKS_SETTINGS, {
                        autoClose: 3000
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getSettings `, err.message)
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        setLoading(false)
                    }
                })
            })
        }
    }, [props])

    const onFormSubmit = values => {
        if (values) {
            setGlobalLoading(true)
            setButtonDisable(true)
            setCreateButtonLoading(true)
            editSettings(props.currentUser.userToken, values).then(res => {
                const multiplierData = res.data
                if (multiplierData && multiplierData.success) {
                    toast.success(QUICKBOOKS_SETTINGS_UPDATED_SUCCESSFULLY, {
                        autoClose: 3000
                    })
                }
                setGlobalLoading(false)
                setButtonDisable(false)
                setCreateButtonLoading(false)

            })
                .catch(err => {
                    console.log(`${ERROR_WHILE__NAME} editSettings `, err.message)
                    toast.dismiss();
                    toast.error(UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500,
                        onClose: () => {
                            setGlobalLoading(false)
                        }
                    })
                })
        }
    }

    const formik = useFormik({
        initialValues: initialFormValues(settings),
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    const handleFormSubmission = (ev) => {
        ev.preventDefault()
        submitButtonRef.current.click()
    }
    return (
        <section id="app-quickbook-settings" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-integrations">
                    <Col xs={12} md={12} lg={12} className="px-0">
                        <div className="app-card">
                            <div className="app-card-content border st-default-rounded-block pad-12">
                                <div className="integrations-bottom-content justify-content-between">
                                    <div className="card-content">
                                        <form
                                            onSubmit={formik.handleSubmit}
                                            noValidate
                                            autoComplete="off">
                                            <div>
                                                <FormQuickBook
                                                    formik={formik}
                                                />
                                                <div className="d-flex mt-3 justify-content-end">
                                                    <button
                                                        type="submit"
                                                        onClick={handleFormSubmission}
                                                        className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(buttonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                                        disabled={buttonDisable}
                                                    >
                                                        {
                                                            createButtonLoading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <span>Save</span>
                                                            )
                                                        }
                                                    </button>
                                                </div>
                                            </div>
                                            <button type="submit" ref={submitButtonRef} className="d-none">submit</button>

                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </div>
            </Container >
        </section >
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(QuickBooksSetting)